import { render, staticRenderFns } from "./DocumentsReport.vue?vue&type=template&id=3ffe8f98&scoped=true"
import script from "./DocumentsReport.vue?vue&type=script&lang=js"
export * from "./DocumentsReport.vue?vue&type=script&lang=js"
import style0 from "./DocumentsReport.vue?vue&type=style&index=0&id=3ffe8f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe8f98",
  null
  
)

export default component.exports